<template>
  <div class="data-analysis">
    <Block class="vip-area" :title="title[0]">
      <div class="winner-flex">
        <MapCity
          :btn="btn"
          :chartMapData="chartMapData"
          :changeData="changeData"
          :pagination="pagination"
        >
          <template #tips>
            <span class="tips">
              {{ title[0] }}
              <br />
              （单位：人次）
            </span>
          </template>
        </MapCity>
      </div>
    </Block>

    <Block class="vip-sex" :title="title[1]">
      <div class="winner-flex" v-if="vipSexData.length > 0">
        <VipSexSvg :vipSexData="vipSexData" />
      </div>
    </Block>

    <Block class="vip-check" :title="title[2]">
      <div class="chart-line">
        <div class="chang-data">
          <el-button
            size="120"
            round
            class="fff-color"
            :class="chartCheckInIndex === index && 'active'"
            v-for="(item, index) in chartCheckInTitle"
            @click="changeSignChartData({ search_mode: item.mode }, index)"
            :key="item.mode"
          >
            {{ item.title }}
          </el-button>
        </div>
        <span class="time">
          {{ time }}
        </span>
        <chart-line
          v-bind="$attrs"
          :chartLineData="chartLineData"
          :legendVisible="false"
          :loading="$attrs.loading"
          :chartLineSettings="chartLineSettings"
          height="32rem"
          :dataEmpty="chartLineData.rows && chartLineData.rows.length === 0"
          :chartOptions="chartOptions"
          :dataZoom="dataZoom"
          :colors="['rgba(220, 196, 161, 0.3)']"
          :style="{ top: '6rem', padding: '0  2rem' }"
        />
      </div>
    </Block>

    <Block class="vip-age" :title="title[3]">
      <div class="winner-flex">
        <p class="tips">（单位：人）</p>
        <div class="svg-box">
          <VipAgeSvg
            v-for="(item, index) in vipAgeData"
            :key="index"
            :age="item"
            :index="index"
          />
        </div>
      </div>
    </Block>

    <Block class="vip-integral " :title="title[4]">
      <div class="winner-flex">
        <VipIntegralSvg
          :vipIntegralData="vipIntegralData"
          :integralTotal="integralTotal"
          v-if="$route.name === 'vipData' && vipIntegralData.length > 0"
        />
        <DistributionSvg
          v-if="
            $route.name === 'distributionData' && vipDistributionData.length > 0
          "
          style="padding-top: 2rem"
          :vipDistributionData="vipDistributionData"
        />
      </div>
    </Block>

    <Block class="vip-charge " :title="title[5]">
      <div class="chart-line">
        <div class="chang-data">
          <el-button
            size="120"
            round
            class="fff-color"
            :class="vipChargeIndex === index && 'active'"
            @click="
              changeRechargeChartData(
                {
                  search_mode: item.mode
                },
                index
              )
            "
            v-for="(item, index) in $route.name === 'vipData'
              ? vipChargeTitle
              : commisionTitle"
            :key="item.mode"
          >
            {{ item.title }}
          </el-button>
        </div>
        <span class="time">
          {{ times }}
        </span>
        <chart-line
          v-bind="$attrs"
          :chartLineData="rechargeData"
          :legendVisible="false"
          :loading="$attrs.loading"
          :chartLineSettings="chartLineSettings"
          height="32rem"
          :dataEmpty="rechargeData.rows && rechargeData.rows.length === 0"
          :chartOptions="chartOptions"
          :dataZoom="dataZoom"
          :colors="['rgba(220, 196, 161, 0.3)']"
          :style="{ top: '6rem', padding: '0  2rem' }"
        />
      </div>
    </Block>
  </div>
</template>
<script>
import VipSexSvg from 'components/Chart/VipSexSvg/'
import chartLine from 'components/Chart/Line/'
import VipAgeSvg from 'components/Chart/VipAgeSvg/'
import VipIntegralSvg from 'components/Chart/VipIntegralSvg/'
import DistributionSvg from 'components/Chart/DistributionSvg/'
import MapCity from 'components/MapCity/'
import Block from '../Block/'

export default {
  name: 'VipDistribution',
  components: {
    MapCity,
    VipSexSvg,
    chartLine,
    VipAgeSvg,
    VipIntegralSvg,
    DistributionSvg,
    Block
  },
  props: {
    title: {
      type: Array
    },
    mode: {
      type: String
    }
  },
  data() {
    this.keyMap = {
      distributors_data: {
        name: 'vipDistributionData',
        distributor_number: 'num',
        level_name: 'name',
        distributor_percentage: 'percentage'
      },
      sign_data: {
        name: 'signData',
        date_time: '时间',
        sign_number: '签到人数',
        subName: 'rows',
        adds: [
          {
            name: 'columns',
            value: ['时间', '签到人数']
          }
        ]
      },
      area_data: {
        name: 'areaData',
        sign_number: '人数',
        member_number: '人数',
        area_name: 'area',
        subName: 'rows',
        adds: [
          {
            name: 'columns',
            value: ['area', '人数']
          }
        ]
      },
      gender_list: {
        name: 'vipSexData',
        member_gender: 'sex',
        member_number: 'num',
        member_percentage: 'percentage'
      },
      integral_list: {
        name: 'vipIntegralData',
        integral_number: 'num',
        point_name: 'text'
      },
      recharge_data: {
        name: 'rechargeData',
        date_time: '时间',
        recharge_amount: '充值金额',
        subName: 'rows',
        adds: [
          {
            name: 'columns',
            value: ['时间', '充值金额']
          }
        ]
      },
      age_data: {
        name: 'vipAgeData',
        age_name: 'range',
        age_value: 'num',
        age_percentage: 'percentage'
      },
      commission_data: {
        name: 'rechargeData',
        date_time: '时间',
        commission_amount: '分销金额',
        subName: 'rows',
        adds: [
          {
            name: 'columns',
            value: ['时间', '分销金额']
          }
        ]
      }
    }
    this.chartCheckInTitle = [
      { title: '实时签到数据', mode: 'real_time' },
      { title: '7天签到数据', mode: 'seven_day' },
      { title: '30天签到数据', mode: 'thirty_day' }
    ]
    this.vipChargeTitle = [
      { title: '实时充值数据', mode: 'real_time' },
      { title: '7天充值数据', mode: 'seven_day' },
      { title: '30天充值数据', mode: 'thirty_day' }
    ]
    this.commisionTitle = [
      { title: '实时佣金数据', mode: 'real_time' },
      { title: '7天佣金数据', mode: 'seven_day' },
      { title: '30天佣金数据', mode: 'thirty_day' }
    ]
    this.dataZoom = [
      {
        type: 'slider',
        start: 0,
        end: 100,
        backgroundColor: 'rgba(220, 196, 161, 0.2)',
        handleStyle: {
          color: 'rgba(220, 196, 161, 1)'
        },
        fillerColor: 'rgba(220, 196, 161, .3)'
      }
    ]
    this.chartOptions = {
      tooltip: {
        axisPointer: {
          type: 'none'
        }
      }
    }
    this.chartLineSettings = {
      area: true,
      areaStyle: {
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              // '#c23531','#2f4554', '#61a0a8',
              offset: 0,
              color: '#dcc4a1' // 0% 处的颜色
            },
            {
              offset: 1,
              color: 'rgba(220, 196, 161, 0.1)' // 100% 处的颜色
            }
          ],
          global: false // 缺省为 false
        }
      }
    }
    this.btn = [
      {
        title: '全部省份',
        mode: this.mode,
        type: 'province'
      },
      {
        title: '全部城市',
        mode: this.mode,
        type: 'city'
      }
    ]
    this.chartMapSettings = {
      position: 'china',
      // selectData: true,
      selectedMode: 'single'
    }
    return {
      time: '',
      times: '',
      chartMapData: {},
      vipSexData: [],
      chartLineData: {},
      vipAgeData: [],
      vipIntegralData: [],
      vipDistributionData: {},
      rechargeData: {},
      integralTotal: '',
      pagination: {
        currentPage: 1,
        recordTotal: -1,
        pageTotal: -1
      },
      chartCheckInIndex: 0,
      vipChargeIndex: 0
    }
  },
  created() {
    this._getMemberAnalyz({
      search_mode: this.mode
    })
    this.signEntry = this.mode === 'member' ? 'member_sign' : 'distributor_sign'
    this.moneyEntry = this.mode === 'member' ? 'rechange' : 'commission'
    this.getVipAreaData({
      search_mode: this.mode,
      curpage: 1,
      see_type: 'province'
    })
  },
  methods: {
    /**
     * 获取数据
     * @param params
     * @private
     */
    _getMemberAnalyz(params) {
      this.api.getMemberAnalyz(params).then(res => {
        this.integralTotal = res.integral_total_number
        this.utils._modifyObjKey(res, this.keyMap)
        this.vipAgeData = res.vipAgeData
        this.vipSexData = res.vipSexData
        this.rechargeData = res.rechargeData
        this.vipIntegralData = res.vipIntegralData
        this.vipDistributionData = res.vipDistributionData
        this.chartLineData = res.signData
      })
    },
    /**
     * 获取会员所在区域分布
     * @param params
     */
    getVipAreaData(params) {
      this.api.getVipAreaData(params).then(res => {
        this.utils._modifyObjKey(res, this.keyMap)
        this.chartMapData = res.areaData
        this.pagination.pageTotal = +res.page_count
      })
    },
    /**
     * 切换签到数据
     * @param params
     * @param index
     */
    changeSignChartData(params, index) {
      if (index >= 0) {
        this.chartCheckInIndex = index
      }
      params.entry_mode = this.signEntry
      this.api.changeData(params).then(res => {
        if (res.sign_data.length > 0) {
          if (params.search_mode === 'real_time') {
            this.time = new Date().toLocaleDateString().replace(/\//g, '-')
          } else {
            this.time = `${res.sign_data[0].date_time}~${
              res.sign_data.slice(-1)[0].date_time
            }`
          }
        }
        this.utils._modifyObjKey(res, this.keyMap)
        this.chartLineData = res.signData
      })
    },

    /**
     * 切换充值数据
     * @param params
     * @param index
     */
    changeRechargeChartData(params, index) {
      if (index >= 0) {
        this.vipChargeIndex = index
      }
      params.entry_mode = this.moneyEntry
      this.api.changeData(params).then(res => {
        if (res.recharge_data.length > 0) {
          if (params.search_mode === 'real_time') {
            this.times = new Date().toLocaleDateString().replace(/\//g, '-')
          } else {
            this.times = `${res.recharge_data[0].date_time}~${
              res.recharge_data.slice(-1)[0].date_time
            }`
          }
        }
        this.utils._modifyObjKey(res, this.keyMap)
        this.rechargeData = res.rechargeData
      })
    },
    /**
     * 切换会员分布数据
     * @param parasm
     */
    changeData(parasm) {
      this.getVipAreaData(parasm)
    }
  }
}
</script>
<style lang="scss">
.data-analysis {
  .vip-area {
    width: 66.9rem;
    height: 46.3rem;

    .winner-flex {
      padding: 5.8rem 4rem 4.5rem;
    }
  }

  .vip-sex {
    width: calc(100% - 69.5rem);
    height: 46.3rem;

    .winner-flex {
      padding-top: 4rem;
    }
  }

  .vip-check,
  .vip-charge {
    width: 100%;
    height: 45.6rem;
  }

  .vip-age {
    width: 61.3rem;
    height: 36.3rem;

    .winner-flex {
      flex-direction: column;
      padding: 3.8rem 6.9rem 7.5rem;

      .tips {
        margin-bottom: 4.8rem;
      }

      .svg-box {
        display: flex;
        width: 100%;
      }

      .vip-age__svg {
        flex: 1;
      }
    }
  }

  .vip-integral {
    width: calc(100% - 63.9rem);
    height: 36.3rem;
  }
}
</style>
